import { BasicPageSortQueryParams } from '..'
import { components } from '../openapi'

export type ParkingEventDTO = components['schemas']['ParkingEvent']
export type ParkingEventDetailsDTO = components['schemas']['ParkingEventDetail']
export type ParkingEventsResponseDTO =
  components['schemas']['ParkingEventsResponse']
export type UpdatePriceDTO = components['schemas']['UpdatePrice']
export type CameraDetailsDTO = components['schemas']['CameraDetails']
// export type ParkingEventsPagingDTO = components['schemas']['']
export type ParkingEventsSortType = components['schemas']['ParkingSortType']
export interface ParkingEventsSortQueryParams extends BasicPageSortQueryParams {
  // sort?: ParkingEventsPagingDTO
}
export type ParkingEventSessionStatus = components['schemas']['SessionStatus']
export type PaymentStatus = components['schemas']['PaymentStatus']
export const paymentStatuses: { [key: string]: PaymentStatus } = {
  FREE: 'FREE',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  INVOICING: 'INVOICING',
  TIMED_OUT: 'TIMED_OUT',
}
